import React from 'react';
import style from './notificationButton.module.scss';
import { ButtonLaunchingPopover } from './buttonLaunchingPopover';
import { AccountNotificationsPage } from './accountNotificationsPage';

interface NotificationButtonOwnProps {
    buttonClass: string;
}

const NotificationButton: React.SFC<NotificationButtonOwnProps> = props => (
    <ButtonLaunchingPopover
        buttonClassName={props.buttonClass}
        childComponentFactory={closePopover => <AccountNotificationsPage closeSelf={closePopover} />}
        popoverBodyClassName={style.AccountNotificationsPopover}
        popoverPosition={'top'}
        popoverHorizontalAlignment={'end'}
    >
        {props.children}
    </ButtonLaunchingPopover>
);
export { NotificationButton };
